import loadable from '@loadable/component';

export const AsyncFamilyFriendly = loadable(() =>
    import(
        /* webpackChunkName: "family-friendly" */
        /* webpackPrefetch: true */
        './'
    )
);

AsyncFamilyFriendly.displayName = 'AsyncFamilyFriendly';
